import Nullstack from 'nullstack';
export default function IconPoolOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-pool-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1c.303 .006 .6 -.045 .876 -.146"
  }), "   ", Nullstack.element("path", {
    d: "M2 16a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 1.13 -.856m5.727 1.717a2.4 2.4 0 0 0 1.143 -.861"
  }), "   ", Nullstack.element("path", {
    d: "M15 11v-6.5a1.5 1.5 0 0 1 3 0"
  }), "   ", Nullstack.element("path", {
    d: "M9 12v-3m0 -4v-.5a1.5 1.5 0 0 0 -1.936 -1.436"
  }), "   ", Nullstack.element("path", {
    d: "M15 5h-6"
  }), "   ", Nullstack.element("path", {
    d: "M9 10h1m4 0h1"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}